(function() {
    var __webpack_require__ = {};
    !function() {
        __webpack_require__.r = function(exports) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
            }
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
        };
    }();
    var __webpack_exports__ = {};
    !function() {
        (function() {
            "use strict";
            if (window.__erkBeforeAfterImageInitialized__) {
                return;
            }
            window.__erkBeforeAfterImageInitialized__ = true;
            function syncState(component) {
                const section = component.closest(".erk-before-after-image");
                if (!section) return;
                component.classList.add("is-ready");
                component.dataset.dragEnabled = section.classList.contains("erk-before-after-image--drag-enabled") ? "true" : "false";
            }
            function syncAll(root) {
                const scope = root || document;
                const components = scope.querySelectorAll("erk-before-after-image");
                components.forEach((function(component) {
                    syncState(component);
                }));
            }
            class ERKBeforeAfterImage extends HTMLElement {
                connectedCallback() {
                    syncState(this);
                }
            }
            if (!window.customElements.get("erk-before-after-image")) {
                window.customElements.define("erk-before-after-image", ERKBeforeAfterImage);
            }
            if (document.readyState === "loading") {
                document.addEventListener("DOMContentLoaded", (function() {
                    syncAll();
                }));
            } else {
                syncAll();
            }
            document.addEventListener("shopify:section:load", (function(event) {
                syncAll(event.target);
            }));
        })();
    }();
    !function() {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
    }();
})();